"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { captureRouteError } from "@/core/observability/route-errors";

export function RouteErrorFallback({
  error,
  reset,
  routeLabel,
}: {
  error: Error & { digest?: string };
  reset: () => void;
  routeLabel: string;
}) {
  useEffect(() => {
    captureRouteError({ route: routeLabel, error });
  }, [error, routeLabel]);

  return (
    <main className="mx-auto flex min-h-screen max-w-xl flex-col justify-center px-6 py-12">
      <Card>
        <CardHeader>
          <CardTitle>Something went wrong</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm">
          <p className="text-muted-foreground">
            This workspace view hit an unexpected error. The event has been queued for support review.
          </p>
          {error.digest ? (
            <div className="rounded-md bg-muted p-3 font-mono text-xs text-muted-foreground">
              Error digest: {error.digest}
            </div>
          ) : null}
          <Button onClick={reset}>Try again</Button>
        </CardContent>
      </Card>
    </main>
  );
}
